export default __webpack_public_path__ + "static/media/english-to-vietnamese-screenshot-02.8f8d8718.png";